var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-chip',{class:_vm.chipClass,attrs:{"small":""}},[_vm._v(" "+_vm._s(_vm.chipText)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }